module.exports = __webpack_public_path__ + "img/142.c72db006.jpg";